<template>
  <div>
    <!-- <loading :active.sync="isLoading_login" :is-full-page="fullPage">
        </loading> -->
    <div v-if="isLogin === false">
      <div class='w-100 mx-auto'>
        <b-form class="px-3" @submit.prevent='login()'>
          <b-form-group label-cols="2" label-cols-lg="2" label-size="md"
            label-class="py-0 text-center align-self-center text-nowrap" label="帳號"
            label-for="input-sm">
            <b-form-input size="sm" v-model="member_id" class="font-weight-normal font-up-1"
              style="height:40px" placeholder="請輸入電子信箱">
            </b-form-input>
          </b-form-group>
          <b-form-group label-cols="2" label-cols-lg="2" label-size="md"
            label-class="py-0 text-center align-self-center text-nowrap" label="密碼"
            label-for="input-sm">
            <b-form-input type='password' size="sm" class="font-weight-normal font-up-1"
              style="height:40px" placeholder="請輸入6~12碼字元" v-model="password">
            </b-form-input>
          </b-form-group>
          <div class='d-flex justify-content-around mb-3 mt-4'>
            <a class='btn btn-deepgold w-50 mr-2 py-1' href="https://www.magee.tw/register">註冊會員
            </a>
            <b-button class='btn btn-danger w-50 ml-2 py-1' type="submit">登入</b-button>
          </div>
        </b-form>
        <div class="px-3 d-flex">
          <small class='d-flex align-items-center ml-2'>
            <a href="https://www.magee.tw/forgetpw" class="text-sevenblack pb-1">忘記密碼?</a>
          </small>
          <!-- <b-form-group class="ml-auto mb-0">
						<b-form-checkbox id="checkbox-2" size="sm" name="checkbox-2" value="accepted" unchecked-value="not_accepted">保持登入狀態</b-form-checkbox>
				</b-form-group> -->
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-12 pb-5">
          <p>
            HI, {{userinfo.member_id}}!<br>
            您目前有 {{userinfo.radcount}} 點數
          </p>
          <a class="text-primary" href="#" @click='searchbuylist'>查詢您的試題購買紀錄</a>
          <b-modal v-model='showbuylist' centered title="試題購買紀錄">
            <b-table :items="items">

            </b-table>
            <!-- :fields="fields" -->
          </b-modal>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-right">
          <b-button size="sm" variant="light" @click="Logout()">登出</b-button>
        </div>
      </div>
    </div>
    <b-toast id='error' variant="danger" solid toaster="b-toaster-top-center mt-5"
      header-class="text-center">
      <template v-slot:toast-title>
        <div class="d-flex w-100">
          <strong class="mx-auto">糟糕，無法登入</strong>
        </div>
      </template>
      <div class="row no-gutters" style="font-size:15px">
        <div class="col-12 text-left py-1">
          <div class="py-1">未加入會員，請先<a class="px-1 border-bottom border-dark"
              href="https://www.magee.tw/register">註冊會員</a>
          </div>
          <div class="py-1">已加入會員，無法登入時<a class="px-1 border-bottom border-dark"
              href="https://www.magee.tw/changepw">忘記密碼</a>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center py-1 text-deepgold">
          <span>客服專線 <a class="px-1 border-bottom border-dark text-deepgold"
              href="tel:0227338118">022733-8118</a>
          </span>
        </div>
      </div>
    </b-toast>
  </div>
</template>

<script>
  export default {
    name: 'comlogin',
    data() {
      return {
        member_id: '',
        password: '',
        showbuylist: false,
        items: [],
      };
    },
    methods: {
      login() {
        this.$store.dispatch('indexPage/Login', {
          member_id: this.member_id,
          password: this.password,
        }).then((response) => {
          if (!response.data.status) {
            this.$bvToast.show('error');
          } else {
            this.$bvToast.hide('error');
          }
        });
      },
      Logout() {
        localStorage.removeItem('api_token');
        this.$store.commit('indexPage/isLogin', {
          TF: false,
          member_id: 'test',
        });
        this.$store.commit('indexPage/saveUserinfo', {});
      },
      searchbuylist() {
        this.showbuylist = true;
        this.$store.dispatch("indexPage/getRecord").then((data)=>{
          // console.log(data.data);
          this.items=_.map(data.data.result,(item,keys)=>{
            return {
              試題代號: item.exam_re,
              試題名稱: item.remark,
              花費點數: 10,
            }
          });
        });
      }
    },
    mounted() {
      this.$store.dispatch('indexPage/checkLogin');
      // if (this.isLogin === false) {
      //   this.$bvToast.show('my-toast');
      // }
    },
    computed: {
      // isLoading_login: {
      //   get() {
      //     return this.$store.state.indexPage.isLoading_login;
      //   },
      // },
      isLogin: {
        get() {
          return this.$store.state.indexPage.isLogin;
        },
      },
      status: {
        get() {
          return this.$store.state.indexPage.status;
        },
      },
      userinfo: {
        get() {
          return this.$store.state.indexPage.userinfo;
        },
      },
    },
  };

</script>

<style lang="scss">

</style>
